import type { Template } from "@/types";

export const LA_04_H0_V4: Template[] = [
    {
        id: "la-04-h0v4-01",
        name: "LA 01 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 64, y: 109, width: 266, height: 391, rotation: 0, imageRotation: 0 },
            { id: "2", x: 338, y: 109, width: 266, height: 391, rotation: 0, imageRotation: 0 },
            { id: "3", x: 612, y: 109, width: 266, height: 391, rotation: 0, imageRotation: 0 },
            { id: "4", x: 948, y: 30, width: 334, height: 469, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-02",
        name: "LA 02 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 58, y: 44, width: 304, height: 443, rotation: 0, imageRotation: 0 },
            { id: "2", x: 370, y: 44, width: 303, height: 443, rotation: 0, imageRotation: 0 },
            { id: "3", x: 681, y: 44, width: 303, height: 443, rotation: 0, imageRotation: 0 },
            { id: "4", x: 992, y: 44, width: 303, height: 443, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-03",
        name: "LA 03 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 57, y: 53, width: 277, height: 424, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 53, width: 277, height: 424, rotation: 0, imageRotation: 0 },
            { id: "3", x: 733, y: 53, width: 277, height: 424, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 53, width: 277, height: 424, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-04",
        name: "LA 04 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 377, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 475, y: 72, width: 255, height: 391, rotation: 0, imageRotation: 0 },
            { id: "3", x: 738, y: 72, width: 255, height: 391, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1001, y: 72, width: 255, height: 391, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-05",
        name: "LA 05 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 91, y: 42, width: 304, height: 449, rotation: 0, imageRotation: 0 },
            { id: "2", x: 403, y: 42, width: 168, height: 221, rotation: 0, imageRotation: 0 },
            { id: "3", x: 403, y: 271, width: 168, height: 221, rotation: 0, imageRotation: 0 },
            { id: "4", x: 853, y: 38, width: 322, height: 449, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-06",
        name: "LA 06 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 43, y: 37, width: 326, height: 456, rotation: 0, imageRotation: 0 },
            { id: "2", x: 541, y: 186, width: 221, height: 308, rotation: 0, imageRotation: 0 },
            { id: "3", x: 770, y: 186, width: 221, height: 308, rotation: 0, imageRotation: 0 },
            { id: "4", x: 999, y: 186, width: 221, height: 308, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-07",
        name: "LA 07 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 91, y: 42, width: 167, height: 220, rotation: 0, imageRotation: 0 },
            { id: "2", x: 91, y: 271, width: 167, height: 220, rotation: 0, imageRotation: 0 },
            { id: "3", x: 266, y: 42, width: 318, height: 449, rotation: 0, imageRotation: 0 },
            { id: "4", x: 851, y: 37, width: 326, height: 449, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-08",
        name: "LA 08 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 768, y: 42, width: 318, height: 449, rotation: 0, imageRotation: 0 },
            { id: "2", x: 175, y: 37, width: 326, height: 449, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1094, y: 42, width: 167, height: 220, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1094, y: 271, width: 167, height: 220, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-09",
        name: "LA 09 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 92, y: 37, width: 316, height: 456, rotation: 0, imageRotation: 0 },
            { id: "2", x: 426, y: 88, width: 238, height: 354, rotation: 0, imageRotation: 0 },
            { id: "3", x: 688, y: 88, width: 238, height: 354, rotation: 0, imageRotation: 0 },
            { id: "4", x: 945, y: 37, width: 316, height: 456, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h0v4-10",
        name: "LA 10 - H0V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h0_v4_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 139, y: 112, width: 220, height: 308, rotation: 0, imageRotation: 0 },
            { id: "2", x: 367, y: 112, width: 219, height: 308, rotation: 0, imageRotation: 0 },
            { id: "3", x: 594, y: 112, width: 219, height: 308, rotation: 0, imageRotation: 0 },
            { id: "4", x: 993, y: 37, width: 316, height: 456, rotation: 0, imageRotation: 0 }
        ],
    }
];